module.exports = __webpack_public_path__ + "static/img/home43.b1d0a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home43.png
// module id = Wraz
// module chunks = 13